import ChipRow from "./chip-row";
import { studioAddSongUrl, studioHistoryUrl } from "../studio-link";

// Shares the `.mood` slide-up sheet styling, like Skins, Advanced and
// Feedback. The chips are links: a host with its own way of opening pages
// (the extension's popup, the web panel's parent) takes over through the
// click handlers; without one they open like any other link.
export default function StudioSheet({
  open,
  studioUrl,
  studioSaveUrl = null,
  saved = false,
  onOpenClick,
  onSaveClick,
  onRemoveClick,
  onHistoryClick,
  // Off YouTube (the gate), the sheet also opens the playlist: Studio's
  // home, where Save Song lands.
  onPlaylistClick = null,
}) {
  const historyUrl = studioHistoryUrl(studioUrl);
  const addSongUrl = studioAddSongUrl(studioUrl, "footer-add-song") || studioUrl;
  // A song on the page: Save Song keeps it for the Studio playlist without
  // leaving the page, and once it's saved the sheet says so and offers
  // Remove Song instead. A host that can't keep songs (no onRemoveClick)
  // only ever shows Save Song, which opens Studio with the song.
  const isSaved = !!studioSaveUrl && saved && !!onRemoveClick;
  const items = [
    ...(studioSaveUrl && !isSaved
      ? [
          {
            key: "save",
            label: "Save Song",
            title: "Keep this song in your Studio playlist, with this sound",
            href: studioSaveUrl,
            onClick: onSaveClick ? () => onSaveClick(studioSaveUrl) : null,
          },
        ]
      : []),
    ...(isSaved
      ? [
          {
            key: "remove",
            label: "Remove Song",
            title: "Take this song out of your Studio playlist",
            href: "#!",
            onClick: () => onRemoveClick(),
          },
        ]
      : []),
    {
      key: "add",
      label: "Add Song",
      title: "Choose a song file and play it slowed + reverb in Slowed Studio",
      href: addSongUrl,
      onClick: onOpenClick ? () => onOpenClick(addSongUrl) : null,
    },
    ...(onPlaylistClick && studioUrl
      ? [
          {
            key: "playlist",
            label: "Open Playlist",
            title: "Your Slowed Studio playlist",
            href: studioUrl,
            onClick: () => onPlaylistClick(studioUrl),
          },
        ]
      : []),
    ...(historyUrl
      ? [
          {
            key: "history",
            label: "Open History",
            title: "The songs you last used Slowed on, in Studio's player",
            href: historyUrl,
            onClick: onHistoryClick ? () => onHistoryClick(historyUrl) : null,
          },
        ]
      : []),
  ];

  return (
    <div
      id="mood-sheet"
      className={`mood mood--studio${open ? " mood--open" : ""}`}
      aria-label="Studio"
      aria-hidden={!open}
      {...(!open ? { inert: true } : {})}
    >
      <div className="mood__header">
        <div className="content__title">Studio</div>
        <p className="mood__subtitle">
          {isSaved
            ? "This song is saved in your Studio playlist."
            : "Your slowed + reverb creator, for your own songs."}
        </p>
      </div>

      <ChipRow>
        {items.map((item) => (
          <a
            key={item.key}
            className="mood__chip"
            href={item.href}
            target="_blank"
            rel="noopener noreferrer"
            title={item.title}
            tabIndex={open ? 0 : -1}
            onClick={(event) => {
              if (!item.onClick) return;
              event.preventDefault();
              item.onClick();
            }}
          >
            <span className="mood__chip-name">{item.label}</span>
          </a>
        ))}
      </ChipRow>
    </div>
  );
}
